import { Injectable, signal } from '@angular/core';

/** The image currently shown in the global large-preview lightbox. */
export interface PreviewImage {
    url: string;
    alt: string;
}

/**
 * Drives the global image lightbox ({@link ImagePreview}, mounted once in the
 * layout). Any component can call `open(url)` to show an image full-size —
 * handy for inspecting AI-generated candidates before picking one.
 */
@Injectable({ providedIn: 'root' })
export class ImagePreviewService {
    readonly current = signal<PreviewImage | null>(null);

    open(url: string | null | undefined, alt = 'Preview'): void {
        if (url) this.current.set({ url, alt });
    }

    close(): void {
        this.current.set(null);
    }
}
